import React, { RefObject } from 'react';
import { cn } from '../../../../lib/utils';
import NodeHeader from '../NodeHeader/NodeHeader';
import BotResponseTreeNode from '../../../../types/BotBuilder/BotResponseTreeNode';

interface BotBuilderNodeProps {
  title: string;
  deleteButtonRef?: RefObject<HTMLButtonElement>;
  onNodeDelete?: () => Promise<void>;
  sourceNode?: BotResponseTreeNode;
  onNodeAdd?: (newNode: BotResponseTreeNode) => void;
  category?: string | null;
  showAddButton?: boolean;
  addButtonTitle?: string;
  isLocked?: boolean;
}

function BotBuilderNode({
  title,
  children,
  deleteButtonRef,
  onNodeDelete,
  sourceNode,
  onNodeAdd,
  category = null,
  showAddButton = true,
  addButtonTitle,
  isLocked = false
}: React.PropsWithChildren<BotBuilderNodeProps>): React.ReactElement {
  return (
    <div
      className={cn(
        'relative p-4 rounded-lg w-[28rem] min-h-[3.5rem]',
        'border border-[#057D99]',
        'bg-[#E6F2F5]',
        'before:absolute before:inset-[-20px] before:z-[-1] before:pointer-events-auto'
      )}
    >
      <NodeHeader
        nodeTitle={title}
        deleteButtonRef={deleteButtonRef}
        onNodeDelete={onNodeDelete}
        isLocked={isLocked}
      />
      {children}
    </div>
  );
}

export default BotBuilderNode;
